import './ScrollingCardsPracticeList.scss'

import React, { useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { Card } from 'react-bootstrap'
import parse from 'html-react-parser'

import WebShare from '../../../web-share'
import SubscriptionContext from '../../contexts/SubscriptionContext'
import {
  ROUTE_ACTIVITIES_BREATHING_ALL,
  ROUTE_ACTIVITIES_COPINGSKILLS_ALL,
  ROUTE_ACTIVITIES_MEDITATION_ALL,
  ROUTE_MEMBERSHIP
} from '../../helpers/Paths'
import { buildRequestURL } from '../../api'
import { navigateTo } from '../index'
import alternativeCourseImage from '../../../../assets/images/alternative-course-image.jpeg'

const practicesWithIntros = [
  ROUTE_ACTIVITIES_BREATHING_ALL,
  ROUTE_ACTIVITIES_MEDITATION_ALL,
  ROUTE_ACTIVITIES_COPINGSKILLS_ALL
]

/**
 * ScrollingCards Practice Cards component. Used to display a practice cards title and preview with horizontally scrolling
 */
export default function ScrollingCardsPracticeList({
  practices,
  baseUrl,
  emptyText = 'Nothing here yet',
  lockedReturnPath = null,
  returnPath = null
}) {
  const history = useHistory()
  const { userHasPremiumAccess } = useContext(SubscriptionContext)

  /**
   * Helper function to get the practice URL
   * @param {string} practiceId - The practice ID
   * @param {boolean} includeHost - Whether to include the host in the URL
   * @returns {string} - The practice URL
   */
  const getPracticeUrl = (practiceId, includeHost = true) => {
    const hasIntro = practicesWithIntros.includes(baseUrl)

    let url = baseUrl + (hasIntro ? '/intro/' : '/') + practiceId

    // Add host if needed
    if (includeHost) url = window.location.origin + url

    return url
  }

  /**
   * Simple click handler
   */
  const handleClick = practiceId => {
    let url = getPracticeUrl(practiceId, false)

    // Is this practice item locked?
    if (!userHasPremiumAccess) {
      url = buildRequestURL(ROUTE_MEMBERSHIP, {
        returnPath: lockedReturnPath ?? baseUrl
      })
    } else if (returnPath) {
      url = buildRequestURL(url, { returnPath })
    }

    navigateTo(url, history)
  }

  return (
    <div className='scrolling-card-practice-wrapper'>
      <div className='scrolling-card-practice-cards d-flex py-4'>
        {practices && practices.length > 0 ? (
          practices.map(practice => (
            <Card
              className='practice-cards me-4 p-0'
              key={practice.term_id || practice.ID}
            >
              <div
                className='practice-cards-image cursor-pointer'
                onClick={() => handleClick(practice.term_id || practice.ID)}
              >
                <Card.Img
                  variant='top'
                  src={practice.featured_image_url || alternativeCourseImage}
                  loading='lazy'
                />
              </div>

              <Card.Body className='practice-cards-body align-center px-3 py-2'>
                <Card.Title className='practice-cards-body-title w-100 mb-0 d-flex gap-2 justify-content-between align-items-center'>
                  <p
                    className='align-center cursor-pointer gap-1 mb-0 text-wrap'
                    onClick={() => handleClick(practice.term_id || practice.ID)}
                  >
                    {!userHasPremiumAccess && <i className='bi bi-lock'></i>}
                    <span>
                      {(practice.title && parse(practice.title)) ||
                        practice.post_title}
                    </span>
                  </p>

                  <WebShare
                    text={practice.title && parse(practice.title)}
                    color='text-black'
                    iconFill={false}
                    size='fs-5'
                    url={getPracticeUrl(practice.term_id)}
                  />
                </Card.Title>
              </Card.Body>
            </Card>
          ))
        ) : (
          <div className='no-cards'>
            <p>{emptyText}</p>
          </div>
        )}
      </div>
    </div>
  )
}
